import o from "./ghl-ui.es707.js";
import e from "./ghl-ui.es708.js";
import t from "./ghl-ui.es704.js";
import m from "./ghl-ui.es706.js";
function s(r) {
  return t(r) ? o(m(r)) : e(r);
}
export {
  s as default
};
